<template>
  <v-app-bar flat color="transparent" class="mt-3">
    <div>
      <div
        id="search_bar"
        flat
        color="transparent"
        class="pa-0 ma-0"
        style="display:grid;align-items:center;grid-column-gap:2rem;grid-template-columns: max-content 4fr 1fr;width:100%;"
      >
        <div>
          <div class="subtitle">
            {{ $store.getters.user.account_name }}
          </div>
          <div class="text-caption">
            {{ $moment().format("ddd") + "," + $moment().format("LL") }}
          </div>
        </div>
        <v-autocomplete
          hide-no-data
          outlined
          hide-details
          clearable
          label="Pretraga sadržaja"
          placeholder="Unesite naziv artikla, ili klijenta, ili dobavljača"
          rounded
          :loading="results_loading"
          :items="result_items"
          :search-input.sync="search_text"
          prepend-inner-icon="mdi-magnify"
          item-text="naziv"
          item-value="id"
        >
          <template v-slot:item="{ item }">
            <div
              @click="open_item(item)"
              style="display:grid;grid-template-columns: max-content max-content 1fr max-content max-content;grid-column-gap: 1rem;align-items:center;"
            >
              <v-chip
                :class="get_class(item.tip)"
                label
                :color="get_color(item.tip)"
                >{{ $t("type_" + item.tip) }}</v-chip
              >
              <div>{{ [1, 4, 3].includes(item.tip) ? "" : item.ref }}</div>
              <div>{{ item.naziv }}</div>
              <div>{{ $n(parseFloat(item.s_value).toFixed(2)) }}</div>
              <div>
                {{
                  ![1, 4, 3].includes(item.tip)
                    ? $moment(item.s_date).format("DD.MM.YYYY.")
                    : null
                }}
              </div>
            </div>
          </template>
        </v-autocomplete>
        <div
          style="display:grid;grid-template-columns:repeat(9,1fr);align-items:center;grid-column-gap:0.2rem;"
        >
          <v-tooltip
            left
            color="#e9c46a"
            open-on-hover
            open-delay="350"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                :content="total_unread"
                offset-y="22px"
                offset-x="27"
                color="red"
                :value="total_unread > 0"
              >
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="show_user_messages"
                >
                  <sabira_icon
                    icon="system_message"
                    :strokewidth="4"
                  ></sabira_icon>
                </v-btn>
              </v-badge>
            </template>
            <span>Sistemska poruka</span>
          </v-tooltip>
          <v-tooltip
            left
            color="#e9c46a"
            open-on-hover
            open-delay="350"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="show_menu_options = true"
              >
                <sabira_icon icon="plus" :strokewidth="4"></sabira_icon>
              </v-btn>
            </template>
            <span>Novi unos</span>
          </v-tooltip>
          <v-tooltip
            left
            color="#e9c46a"
            open-on-hover
            open-delay="350"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" v-on:click="settings">
                <sabira_icon icon="cogwheel" :strokewidth="4"></sabira_icon>
              </v-btn>
            </template>
            <span>Postavke računa</span>
          </v-tooltip>
          <v-tooltip
            :key="object_key"
            left
            color="#e9c46a"
            open-delay="350"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                style="height:100%;"
                v-on:click="show_user_settings"
              >
                <v-badge
                  :content="user_status !== null ? user_status : null"
                  color="red"
                  offset-y="0.5rem"
                  offset-x="1rem"
                  :value="user_status !== null"
                >
                  <div
                    style="display:grid;align-items:center;overflow:hidden;height:2rem;border-radius:50%;height:2rem;width:2rem;"
                    class="secondary white--text"
                    v-if="$store.getters.user.image_user == null"
                  >
                    <div class="pa-1">{{ get_avatar_initials() }}</div>
                  </div>
                  <v-avatar v-else :size="34">
                    <v-img contain :src="$store.getters.user.image_user" />
                  </v-avatar>
                </v-badge>
              </v-btn>
            </template>
            <span>{{ $store.getters.user.name }}</span>
          </v-tooltip>
          <v-tooltip
            left
            color="#e9c46a"
            open-on-hover
            open-delay="350"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                href="https://sabira.ba/documentation/sabira_korisnicko_uputstvo.pdf"
                target="_new"
              >
                <sabira_icon icon="tutorial" :strokewidth="4"></sabira_icon>
              </v-btn>
            </template>
            <span>Uputstvo</span>
          </v-tooltip>
          <v-tooltip
            left
            color="#e9c46a"
            open-on-hover
            open-delay="350"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="show_email_support = true"
              >
                <sabira_icon
                  icon="customer-support"
                  :strokewidth="4"
                ></sabira_icon>
              </v-btn>
            </template>
            <span>Podrška</span>
          </v-tooltip>
          <v-tooltip
            left
            color="#e9c46a"
            open-on-hover
            open-delay="250"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <v-switch
                  icon
                  mdi-toggle-switch
                  flat
                  :value="darkMode"
                  @change="toggleDarkMode"
                  style="padding-top:1.4rem; padding-left:0.5em;"
                ></v-switch>
              </div>
            </template>
            <div>
              Light/Dark
            </div>
          </v-tooltip>
          <v-tooltip
            left
            color="#e9c46a"
            open-on-hover
            open-delay="350"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" v-on:click="logout">
                <sabira_icon icon="logout" :strokewidth="4"></sabira_icon>
              </v-btn>
            </template>
            <span>Izlaz</span>
          </v-tooltip>
        </div>
      </div>
      <v-dialog
        persistent
        v-model="show_menu_options"
        width="65rem"
        scrollable
        fixed-height="40rem"
      >
        <v-card color="background">
          <v-toolbar flat color="primary white--text">
            <div
              style="display:grid; grid-template-columns: 1fr max-content; align-items:center;"
            >
              <sabira_icon
                :strokewidth="3"
                class="mr-3"
                :height="40"
                :width="40"
                icon="question"
                fill="white"
              />
              <v-toolbar-title>
                Kreiranje dokumenta po izboru
              </v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-toolbar-items>
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Pretraga"
                  dense
                  clearable
                  @click:clear="clearSearch"
                  hide-details
                  outlined
                  dark
                  color="white"
                  v-model="searchDocuments"
                ></v-text-field>
              </v-toolbar-items>
            </div>
          </v-toolbar>
          <v-card-text class="pa-0 ma-0 mt-4" style="height:50rem;">
            <div class="master_grid">
              <template v-for="(item, index) in filteredItems">
                <v-hover :key="'hvr_' + index" v-slot="{ hover }">
                  <v-card
                    @click="open_section({ event: item.event })"
                    flat
                    :color="
                      darkMode
                        ? hover
                          ? 'quaternary lighter-1'
                          : 'tertiary'
                        : hover
                        ? 'background darken-1'
                        : 'white'
                    "
                    style="border-radius: 1rem;overflow:hidden;"
                    :key="'card_' + index"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-card-text
                      style="display:grid; grid-template-columns: max-content 1fr;align-items:center;grid-column-gap:1rem;"
                    >
                      <div
                        class="primary"
                        style="display:grid;align-items:center;justify-items:center;border-radius: 50%;"
                      >
                        <sabira_icon
                          :height="39"
                          :width="39"
                          class="pa-2"
                          :icon="item.icon"
                          :strokewidth="3"
                          fill="#fff"
                        ></sabira_icon>
                      </div>
                      <div>
                        <div
                          class="body-1"
                          style="font-family: 'Open Sans';font-weight: 500;"
                        >
                          {{ $t(item.key) }}
                        </div>
                        <div class="body-2">
                          {{ $t(item.key + "_description") }}
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </template>
            </div>
          </v-card-text>
          <v-card-actions class="background">
            <v-btn text @click="close_dialog()">Zatvori</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <sabira_component
        v-if="active_result !== null"
        :id="active_result.id"
        :selected="{ id: active_result.id }"
        :visible="active_result.visible"
        :component_location="active_result.component_location"
        close="comp_close"
        update="comp_close"
      ></sabira_component>

      <sabira_payment_reminder
        :visible="show_payment_reminder"
        close="close_payment_reminder"
      >
      </sabira_payment_reminder>
      <sabira_email_support
        :sender="email.sender"
        :message="email.message"
        :subject="email.subject"
        :recipients="email.recipients"
        :visible="show_email_support"
        close="close_support_dialog"
      ></sabira_email_support>
    </div>
  </v-app-bar>
</template>
<script>
export default {
  components: {
    sabira_payment_reminder: () => import("@/components/payment_reminder"),
    sabira_component: () => import("@/components/sabira_component"),
    sabira_icon: () => import("@/components/sabira_icon"),
    sabira_email_support: () => import("@/components/email_support"),
  },
  data() {
    return {
      darkMode: false,
      show_email_support: false,
      searchDocuments: null,
      eventTimers: {},
      timerId: {},
      email: {
        recipients: [
          {
            name: "info@webpage.ba",
            email: "info@webpage.ba",
          },
        ],
        sender: {
          name: this.$store.getters.user.name,
          email: this.$store.getters.user.email,
        },
        subject: null,
        message: null,
      },
      show_payment_reminder: false,
      payment_reminder_last_shown: null,
      object_key: new Date().getTime(),
      user_status: null,
      cancellation_token: null,
      results_loading: false,
      search_results_dialog: false,
      is_loading: false,
      total_unread: 0,
      active_result: null,
      search_results: [],
      search_text: null,
      show_menu_options: false,
      naslov: "SABIRA",
      result_items: [],
      items: [
        {
          icon: "product",
          key: "product",
          event: "show_product",
          translationKey: "Artikal",
        },
        {
          icon: "category",
          key: "category",
          event: "show_category",
          translationKey: "Kategorija",
        },
        {
          icon: "client",
          key: "client",
          event: "show_klijent",
          translationKey: "Klijent",
        },
        {
          icon: "supplier",
          key: "supplier",
          event: "show_supplier",
          translationKey: "Dobavljač",
        },
        {
          icon: "order",
          key: "order",
          event: "show_order",
          translationKey: "Narudžba",
        },
        {
          icon: "stock_add",
          key: "stock_add",
          event: "show_stock_add",
          translationKey: "Prijem robe",
        },
        {
          icon: "stock_return",
          key: "stock_return",
          event: "show_return_stock",
          translationKey: "Povrat robe",
        },
        {
          icon: "stock_delete",
          key: "stock_delete",
          event: "show_stock_writeoff",
          translationKey: "Otpis robe",
        },
        {
          icon: "stock_check",
          key: "inventory",
          event: "show_stock_inventory",
          translationKey: "Popis robe",
        },
        {
          icon: "invoice",
          key: "invoice",
          event: "show_faktura",
          translationKey: "Faktura",
        },
        {
          icon: "inbox",
          key: "expense",
          event: "show_expense",
          translationKey: "Trošak",
        },
        {
          icon: "ko",
          key: "ko_note",
          event: "show_ko_note",
          translationKey: "Knjižna obavijest",
        },
        {
          icon: "payment",
          key: "payment",
          event: "show_payment",
          translationKey: "Uplata",
        },
        {
          icon: "expense",
          key: "expense_payment",
          event: "show_expense_payment",
          translationKey: "Isplata",
        },
        {
          icon: "offer",
          key: "offer",
          event: "show_offer",
          translationKey: "Ponuda",
        },
        {
          icon: "contract",
          key: "contract",
          event: "show_contract",
          translationKey: "Ugovor",
        },
        {
          icon: "work_order",
          key: "work_order",
          event: "show_work_order",
          translationKey: "Radni nalog",
        },
        {
          icon: "asset",
          key: "asset",
          event: "show_asset",
          translationKey: "Sredstvo",
        },
        {
          icon: "money_bag",
          key: "marketing_budget",
          event: "show_marketing_budget",
          translationKey: "Marketing budžet",
        },
        {
          icon: "marketing",
          key: "marketing_campaign",
          event: "show_campaign",
          translationKey: "Marketing kampanja",
        },
        {
          icon: "positions",
          key: "position",
          event: "show_position",
          translationKey: "Pozicija",
        },
        {
          icon: "department",
          key: "department",
          event: "show_department",
          translationKey: "Odjel",
        },
        {
          icon: "responsibilities",
          key: "responsibilities",
          event: "show_responsibilities",
          translationKey: "Odgovornost",
        },
        {
          icon: "hr",
          key: "employee",
          event: "show_employee",
          translationKey: "Uposlenik",
        },
        {
          icon: "worktime",
          key: "timesheet",
          event: "show_employee_time_sheet",
          translationKey: "Šihtarica radno vrijeme",
        },
        {
          icon: "ld",
          key: "ld",
          event: "show_salary",
          translationKey: "Lični dohodak",
        },
        {
          icon: "goal",
          key: "goals",
          event: "show_pr_goals",
          translationKey: "Ciljevi",
        },
        {
          icon: "memo",
          key: "memo",
          event: "show_memo",
          translationKey: "Memorandum",
        },
        {
          icon: "todo",
          key: "new_note",
          event: "show_new_note_dialog",
          translationKey: "Bilješka",
        },
        {
          icon: "calendar",
          key: "calendar_event",
          event: "show_calendar_event",
          translationKey: "Kalendar",
        },
        {
          icon: "account",
          key: "account",
          event: "show_account",
          translationKey: "Firma",
          restricted: true,
        },
        {
          icon: "user",
          key: "user",
          event: "show_user",
          translationKey: "Korisnik",
          restricted: true,
        },
        {
          icon: "edit_write",
          key: "sys_message",
          event: "show_sys_message_dialog",
          translationKey: "Sistemska poruka",
          restricted: true,
        },
      ],
    };
  },
  watch: {
    "$store.state.user": {
      handler() {
        if (
          typeof this.$store.getters.user.valid_until !== "undefined" &&
          this.$store.getters.user.valid_until !== null &&
          this.$moment(this.$store.getters.user.valid_until).valueOf() >=
            this.$moment(new Date()).valueOf()
        ) {
          this.user_status = "PRO";
        } else {
          this.user_status = null;
        }
        this.object_key = new Date().getTime();
      },
      deep: true,
      immediate: true,
    },
    search_text: {
      handler() {
        this.execute_search();
      },
      immediate: false,
    },
  },
  methods: {
    toggleDarkMode: function() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.darkMode = !this.darkMode;
      localStorage.setItem("darkMode", this.darkMode);
    },
    clearSearch() {
      // Clear the search query when the clear button is clicked
      this.searchDocuments = "";
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("close_payment_reminder", () => {
        this.payment_reminder_last_shown = new Date().getTime();
        this.show_payment_reminder = false;
      });
      this.$webpageEventBus.$on("comp_close", () => {
        this.active_result = null;
      });
      this.$webpageEventBus.$on("close_support_dialog", () => {
        this.show_email_support = false;
      });
      this.$webpageEventBus.$on("calendar_update", () => {
        this.eventNotification();
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("comp_close");
      this.$webpageEventBus.$off("close_calendar_update");
    },
    open_item(item) {
      var a_result = {};
      switch (item.tip) {
        case 0:
          a_result.component_location = "components/invoice";
          break;
        case 1:
          a_result.component_location = "components/client";
          break;
        case 2:
          a_result.component_location = "components/offer";
          break;
        case 3:
          a_result.component_location = "components/supplier";
          break;
        case 4:
          a_result.component_location = "components/product";
          break;
        case 5:
          a_result.component_location = "components/payment";
          break;
        case 6:
          a_result.component_location = "components/contract";
          break;
        case 7:
          a_result.component_location = "components/expense_payment";
          break;
      }
      a_result.id = item.id;
      //a_result.visible = true;
      this.active_result = a_result;
      this.active_result.visible = true;
    },
    get_color(type) {
      switch (type) {
        case 0:
          return "primary";
        case 1:
          return "secondary";
        case 2:
          return "#F26419";
        case 3:
          return "#F3D34A";
        case 4:
          return "#8491d3";
        case 5:
          return "#3ba272";
        case 6:
          return "#61E294";
        case 7:
          return "#9a60b4";
        default:
          return "#6cadd8";
      }
    },
    get_class(type) {
      switch (type) {
        case 0:
          return "white--text";
        case 1:
          return "white--text";
        case 2:
          return "white--text";
        case 3:
          return "black--text";
        case 4:
          return "white--text";
        case 5:
          return "white--text";
        case 6:
          return "black--text";
        case 7:
          return "white--text";
        default:
          return null;
      }
    },
    cancel_search() {
      this.search_results_dialog = null;
      this.cancellation_token.cancel("Korisnik je prekinuo pretragu.");
      this.results_loading = false;
    },
    execute_search() {
      const CancelToken = this.$http.CancelToken;
      this.cancellation_token = CancelToken.source();

      this.$http({
        method: "POST",
        url: "/search",
        cancelToken: this.cancellation_token.token,
        data: {
          search_text: this.search_text,
          account_id: this.$store.getters.user.account_id,
        },
      })
        .then((resp) => {
          if (resp.status == 200) {
            this.result_items = resp.data[0];
          }
        })
        .catch((e) => {
          alert(e);
        })
        .finally(() => {
          this.results_loading = false;
        });
    },
    get_messages1() {
      this.$http({
        method: "POST",
        url: "/get_messages1",
        data: {
          id: 0,
          user_id: this.$store.getters.user.id,
        },
      }).then((resp) => {
        if (resp.data.length) {
          this.total_unread =
            resp.data[0].suma_read == null ? 0 : resp.data[0].suma_read;
        }
      });
    },
    show_user_settings() {
      this.$webpageEventBus.$emit(
        "show_user_settings",
        this.$store.getters.user.id
      );
      this.$webpageEventBus.$emit("toggle_navigation");
    },
    show_user_messages() {
      this.$webpageEventBus.$emit(
        "show_user_messages",
        this.$store.getters.user.id
      );
      this.$webpageEventBus.$emit("toggle_navigation");
    },
    get_avatar_initials() {
      let str = this.$store.getters.user.name;
      let initials = str
        .split(/\s/)
        .reduce((response, word) => (response += word.slice(0, 1)), "");
      return initials.toUpperCase();
    },
    close_dialog() {
      this.show_menu_options = false;
    },
    close_support_dialog() {
      this.show_email_support = false;
    },
    open_section(item) {
      this.$webpageEventBus.$emit(item.event, item.id);
    },
    toggle_nav() {
      this.$webpageEventBus.$emit("toggle_navigation");
    },
    settings() {
      this.$webpageEventBus.$emit(
        "show_settings",
        this.$store.getters.user.account_id
      );
    },
    user_settings() {
      this.$webpageEventBus.$emit(
        "show_user_settings",
        this.$store.getters.user.id
      );
    },
    user_messages() {
      this.$webpageEventBus.$emit(
        "show_user_messages",
        this.$store.getters.user.id
      );
    },
    logout() {
      this.clearAllTimersForUser(this.$store.getters.user.id);
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    eventNotification() {
      this.$http({
        method: "POST",
        url: "/calendar/get_events_notifications",
        data: {
          account_id: this.$store.getters.user.account_id,
          user_id: this.$store.getters.user.id,
        },
      }).then((resp) => {
        this.events = resp.data.map((event) => {
          this.checkNotification(event);
          return event;
        });
      });
    },
    checkNotification(event) {
      const notificationTime = new Date(event.notification_alert).getTime();
      const currentTime = new Date().getTime();

      if (
        notificationTime === currentTime &&
        event.user_id === this.$store.getters.user.id
      ) {
        // Display a status or alert when the notification_alert is equal to the current time
        this.$webpageEventBus.$emit("show_calendar", {
          type: "primary",
          message:
            event.name + ", " + event.notification + " " + "minuta do početka",
          timeout: -1,
        });
      } else {
        // If needed, you can schedule a notification using setTimeout
        const timeUntilNotification = notificationTime - currentTime;
        if (timeUntilNotification > 0) {
          setTimeout(() => {
            // Define timerId within the setTimeout callback's scope
            const timerId = setTimeout(() => {
              // This function will be executed when the notification alert time is reached
              if (event.user_id === this.$store.getters.user.id) {
                this.$webpageEventBus.$emit("show_calendar", {
                  type: "primary",
                  message:
                    event.name +
                    ", " +
                    event.notification +
                    " " +
                    "minuta do početka",
                  timeout: -1,
                });
              }
              // Store the timer ID for this event
              this.$set(this.timerId, event.user_id, {});
              this.$set(this.timerId[event.user_id], event.id, timerId);
            }, timeUntilNotification);
          });
        }
      }
    },
    clearEventTimer(eventId, userId) {
      const timerId = this.timerId[userId] && this.timerId[userId][eventId];
      if (timerId) {
        clearTimeout(timerId);
        delete this.timerId[userId][eventId];

        // If there are no more timers for this user, you can delete the user entry
        if (Object.keys(this.timerId[userId]).length === 0) {
          delete this.timerId[userId];
        }
      }
    },
    clearAllTimersForUser(userId) {
      if (this.timerId[userId]) {
        Object.keys(this.timerId[userId]).forEach((eventId) => {
          const timerId = this.timerId[userId][eventId];
          clearTimeout(timerId);
        });
        // Clear all timers for this user
        delete this.timerId[userId];
      }
    },
    // invoices_check() {
    //   return new Promise((resolve, reject) => {
    //     this.$http({
    //       method: "POST",
    //       data: {
    //         account_id: this.$store.getters.user.account_id,
    //       },
    //       url: "/invoices/check",
    //     })
    //       .then((resp) => {
    //         resolve(resp.data.length ? resp.data[0] : null);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
  },
  computed: {
    nav_items() {
      if (this.$store.getters.user.id !== 1) {
        return this.items.filter((x) => x.restricted !== true);
      } else {
        return this.items;
      }
    },
    filteredItems() {
      if (!this.searchDocuments) {
        return this.nav_items;
      }

      const searchQuery = this.searchDocuments.toLowerCase();
      return this.nav_items.filter((item) => {
        return item.translationKey.toLowerCase().includes(searchQuery);
      });
    },

    switchLabel: function() {
      return this.darkMode ? "light" : "dark";
    },
  },
  beforeMount() {
    this.get_messages1();
    this.visible = true;
  },
  mounted() {
    if (localStorage.getItem("darkMode")) {
      this.darkMode = JSON.parse(localStorage.getItem("darkMode"));
      this.$vuetify.theme.dark = this.darkMode;
    }
    if (
      this.$store.getters.user.valid_until !== null &&
      this.$moment(this.$store.getters.user.valid_until).valueOf() >=
        this.$moment(new Date()).valueOf()
    ) {
      this.user_status = "PRO";

      var dateDifference = this.$moment(this.$store.getters.user.valid_until)
        .startOf("day")
        .diff(this.$moment(new Date()).startOf("day"), "days");
      if (dateDifference < 2) {
        this.show_payment_reminder = true;
      } else {
        this.user_status_text = "Prolazni korisnik";
      }
    }
    this.setup_event_listeners();
    this.$webpageEventBus.$on("new_message", () => {
      this.get_messages1();
      this.visible = true;
    });
    this.$webpageEventBus.$on("close_support_dialog", () => {
      this.show_email_support = false;
    });
    this.eventNotification();
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
};
</script>
<style>
.master_grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  padding: 1rem;
  padding-top: 0;
}

#search_bar .v-toolbar__content {
  padding: 4px 0px !important;
}
</style>
<style scoped>
.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
